import React from 'react';
import Header from 'client/components/Header';
import { faEye } from '@fortawesome/free-solid-svg-icons';
const Center = () => {
    return (React.createElement("div", { className: 'container px-0', style: { 'fontFamily': 'Inter' } },
        React.createElement(Header, { title: 'Center', icon: faEye }),
        React.createElement("div", { className: 'd-flex flex-column px-3' })));
};
export { Center };
